import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

import culinary from "../../Assets/Projects/empower_1.jpg";
import cotubr from "../../Assets/Projects/cotubr_1.jpg";
import shows from "../../Assets/Projects/shows_1.jpg";
import counter from "../../Assets/Projects/counter.jpg";
import todo from "../../Assets/Projects/todo.jpg";
import multiform from "../../Assets/Projects/multiform.jpg";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={culinary}
              isBlog={false}
              title="Empower Culinary Solution"
              description="Empower Culinary Solution is a video course plateform, where teacher and student engage with each other through online courses to facilitate thier learing."
              link="https://www.empowerculinarysolutions.com"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={cotubr}
              isBlog={false}
              title="Cotubr"
              description="Cotubr is a video sharing plateform, where you can sell/purchase video content with legal binding and use it to your own way."
              link="https://www.cotubr.com"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={shows}
              isBlog={false}
              title="Shows Play Online"
              description="Shows Play Online is an online plateforme, where you can watch all your favourite shows like bigboss and other."
              link="https://www.showsplayonline.com"
            />
          </Col>
        </Row>
        <h1 className="project-heading">
          Minor <strong className="purple">Apps </strong>
        </h1>
        <p style={{ color: "white" }}>
          Have a look at some of the apps i made for practice.
        </p>
        <Row>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={counter}
              isBlog={false}
              title="React Advance Counter"
              description="A counter app that has more option to play with then we usually have, made with ReactJs with Dark and Light themes."
              link="http://waqas-counter-app.netlify.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={todo}
              isBlog={false}
              title="Todo App"
              description="A simple todo app to track the daily operations, made with ReactJs with Material UI."
              link="http://waqas-todo-app.netlify.app"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={multiform}
              isBlog={false}
              title="MultiStep Form"
              description="A multistep form, with three section, made with ReactJs with Material UI."
              link="http://waqas-multi-step-form.netlify.app"
            />
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
